// extracted by mini-css-extract-plugin
export default {"Stack":"AQvkezsb","Spacer":"k_YEMSiv"};